// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"d311723e","408":"1f0269fd"}[chunkId] + ".chunk.js";
};